import apiClient from '@/services/axios'

export async function get(venueId, year, week) {
  var response = await apiClient.get(`/VenueTasks/${venueId}/${year}/${week}`)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get venue tasks')
}
